import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { GrooveBadgeDirective, GrooveSurfaceDirective } from '@groove/angular';
import { CATEGORY_LABELS, LEVEL_LABELS } from '../../../blog/blog-categories';
import { youtubeThumbnailUrl } from '../../../blog/blog-jsonld';
import type { BlogPost } from '../../../blog/blog-types';

const VISIBLE_TAG_LIMIT = 3;

@Component({
  selector: 'app-blog-post-card',
  imports: [DatePipe, RouterLink, GrooveSurfaceDirective, GrooveBadgeDirective],
  templateUrl: './blog-post-card.component.html',
  styleUrl: './blog-post-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogPostCardComponent {
  readonly post = input.required<BlogPost>();

  readonly categoryLabel = computed(
    () => CATEGORY_LABELS[this.post().category] ?? this.post().category,
  );

  readonly levelLabel = computed(
    () => LEVEL_LABELS[this.post().level] ?? this.post().level,
  );

  readonly thumbnailUrl = computed(() => {
    const ytId = this.post().youtubeId;
    return ytId ? youtubeThumbnailUrl(ytId, 'hqdefault') : null;
  });

  readonly visibleTags = computed(() =>
    this.post().tags.slice(0, VISIBLE_TAG_LIMIT),
  );
}
